import React from "react";
import "./VideosPage.scss";
import Hero from "../../components/Hero/Hero";
import Article from "../../components/Article/Article";
import Sidebar from "../../components/Sidebar/Sidebar";
import axios from "axios";
import { Redirect } from "react-router-dom/cjs/react-router-dom.min";

// import { API_URL } from "../../config";

// const apiURL = process.env.REACT_APP_API_URL;
const apiURL = `https://brainflix-server-ww0z.onrender.com/videos/`;

class Videos extends React.Component {
  state = {
    videos: [],
    selectedVideo: {},
    isRedirecting: false,
  };

  //intial loading of the video data through function
  componentDidMount() {
    document.title = "brainflix";
    this.getVideosData();
  }

  componentDidUpdate(prevProps, prevState) {
    //find id of video from array and match it to id of the selected video
    if (this.props.match.params.id) {
      if (prevState.selectedVideo.id !== this.props.match.params.id) {
        const foundVideo = this.state.videos.find(
          (video) => video.id === this.props.match.params.id
        );
        if (!foundVideo) {
          this.setState({
            isRedirecting: true,
          });
        }

        this.getVideoById(foundVideo.id);
      }
    }
  }

  //function to access the video data from API
  getVideosData() {
    axios
      // .get(`${apiURL}`)
      .get(apiURL)
      .then((response) => {
        this.setState({
          videos: response.data,
          selectedVideo: response.data[0],
        });
        this.getVideoById(response.data[0].id);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  //once video data has been located, use the videos specific id to set update the main video displayed on homepage along with its details and comments
  getVideoById(id) {
    axios
      .get(apiURL + id)
      .then((response) => {
        this.setState({ selectedVideo: response.data });
      })
      .then(() => {
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  updateSelectedVideo = (videoId) => {
    const foundVideo = this.state.videos.find((video) => video.id === videoId);

    this.setState({ selectedVideo: foundVideo });
  };

  render() {
    const { selectedVideo, videos } = this.state;
    if (this.setState.isRedirecting) {
      return <Redirect to="/404" />;
    }
    return (
      <>
        <Hero poster={selectedVideo.image} />
        <div className="site-container">
          <Article
            video={selectedVideo}
            videos={videos}
            comments={selectedVideo.comments}
          />
          <Sidebar
            videos={videos}
            video={selectedVideo}
            updateSelectedVideo={this.updateSelectedVideo}
          />
        </div>
      </>
    );
  }
}

export default Videos;
